import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import * as dayjs from 'dayjs';
import {BookingHelperService} from '../../../services/booking-helper.service';
import {ToolsService} from '../../../services/tools.service';
import {Subscription} from 'rxjs';
import {BookingResponse} from '../../../modules/booking-v2/types/booking-response';
import {AppConfigService} from '../../../services/app-config.service';
import {DeviceTypeEnum} from '../../../enums/DeviceTypeEnum';

@Component({
  selector: 'app-varden-booking-confirmation-v2',
  templateUrl: './varden-booking-confirmation-v2.component.html',
  styleUrls: ['./varden-booking-confirmation-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VardenBookingConfirmationV2Component implements OnInit, OnDestroy {
  public appointmentToDisplay: string;
  public imgUrl: string;
  public cssClass: string = '';
  public showPriceDelimiter: boolean;
  public isPriceEmpty: boolean;
  public formattedPrice: string;
  private subscriptions: Subscription[] = [];

  constructor(
    public dialogRef: MatDialogRef<VardenBookingConfirmationV2Component>,
    @Inject(MAT_DIALOG_DATA) public data: BookingResponse,
    private appConfigService: AppConfigService,
    private bookingHelperService: BookingHelperService,
    private tools: ToolsService
  ) {
    this.imgUrl = `${appConfigService.appConfig.amazonS3Url}assets/illustrations/heart.png`;
  }

  ngOnInit(): void {
    this.setListeners();
    this.setSelectedDateForDisplay();
    this.cssClass =
      this.tools.getDeviceType() === DeviceTypeEnum.MOBILE
        ? 'mobile-modal'
        : '';
    this.updateIsPriceEmpty();
    this.updateShowDelimiter();
    this.formatPrice();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  public close(): void {
    this.dialogRef.close();
  }

  private updateIsPriceEmpty(): void {
    this.isPriceEmpty =
      this.data == null ||
      this.data.servicePrice == null ||
      this.data.servicePrice === '';
  }

  private updateShowDelimiter(): void {
    this.showPriceDelimiter =
      this.data != null && this.data.terapeutName != null && !this.isPriceEmpty;
  }

  private formatPrice(): void {
    if (
      !this.tools.isNil(this.data.servicePrice) &&
      this.data.servicePrice !== ''
    ) {
      const price = parseFloat(
        this.data.servicePrice.replace(' ', '')
      ).toString();
      if (price === 'NaN') {
        this.formattedPrice = this.data.servicePrice;
      } else {
        this.formattedPrice = `${price} kr`;
      }
    } else {
      this.formattedPrice = '';
    }
  }

  private setSelectedDateForDisplay(): void {
    const d = this.data.date;
    const t = this.data.time;
    let res = '';
    if (d && t) {
      const date = dayjs(`${d} ${t}`, 'YYYY-MM-DD HH:mm');
      res = `${date.format('dddd DD MMMM')} ${date.format('HH:mm')}`;
    }
    this.appointmentToDisplay = res;
  }

  private onCloseAction(): void {
    this.data.closeBookingCallback();
  }

  private setListeners(): void {
    this.subscriptions.push(
      this.dialogRef.beforeClosed().subscribe(() => this.onCloseAction())
    );
  }
}
